import { Typography } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { DefaultModal } from "components/Shared/DefaultModal";
import { useApproveFixtureTask } from "hooks/useFixtureTaskApi";
import { useApproveSeasonTask } from "hooks/useSeasonTaskApi";
import { useState } from "react";
import { useIntl } from "react-intl";

type Props = {
  entityId: string;
  season?: any;
  fixture?: any;
};

export const ApproveButton = ({ entityId, season, fixture }: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const { formatMessage } = useIntl();
  const { mutateAsync: approveSeasonTask, isPending: isSeasonTaskApproving } = useApproveSeasonTask();
  const { mutateAsync: approveFixtureTask, isPending: isFixtureTaskApproving } = useApproveFixtureTask();

  const onApprove = () => {
    if (fixture) {
      approveFixtureTask({
        entityId: entityId,
        seasonId: fixture.seasonId,
        fixtureId: fixture.fixtureId,
      });
    } else if (season) {
      approveSeasonTask({ entityId: entityId, seasonId: season.seasonId });
    }

    setOpenModal(false);
  };

  return (
    <>
      <DefaultButton onClick={() => setOpenModal(true)} icon={<i className="fa-solid fa-check"></i>}>
        {formatMessage({ id: "button.approve" })}
      </DefaultButton>
      {openModal && (
        <DefaultModal
          width={undefined}
          open={openModal}
          onOk={onApprove}
          title={formatMessage(
            { id: "approveConfirmationModal.title" },
            {
              objectType: formatMessage({
                id: fixture ? "objectType.fixture" : "objectType.season",
              }),
            }
          )}
          onCancel={() => setOpenModal(false)}
          cancelText={formatMessage({ id: "button.no" })}
          okButtonProps={{
            loading: isSeasonTaskApproving || isFixtureTaskApproving,
          }}
          cancelButtonProps={{
            disabled: isSeasonTaskApproving || isFixtureTaskApproving,
          }}
          okText={formatMessage({ id: "button.yes" })}
        >
          <Typography.Paragraph style={{ marginBottom: 0 }}>
            {formatMessage(
              { id: "approveConfirmationModal.content.line1" },
              {
                objectType: formatMessage({
                  id: fixture ? "objectType.fixture" : "objectType.season",
                }),
              }
            )}
          </Typography.Paragraph>
          <Typography.Paragraph style={{ marginBottom: 0 }}>
            {formatMessage({ id: "approveConfirmationModal.content.line2" })}
          </Typography.Paragraph>
        </DefaultModal>
      )}
    </>
  );
};
